/**
 * L-NAV-6 — « un donateur est un contact : on le cherche là où on cherche les
 * contacts ». La page « Historique donateur » (`/donations/history`) n'existe
 * plus : son onglet « Donateurs sans fiche » vit dans Contacts
 * (`/contacts?tab=donors`), sa recherche est celle de Contacts et le bloc
 * « Dons » de la fiche.
 *
 * L'ancien chemin vit dans des signets, des liens partagés et l'historique des
 * navigateurs : il REDIRIGE (`replace`, pas d'entrée d'historique — même
 * décision que `legacyMergeRedirects`), et la requête est CONSERVÉE : seul
 * `tab` est réécrit (`?tab=unmatched` ou `?tab=search` ⇒ `tab=donors`), tout
 * autre paramètre suit.
 *
 * Aucune garde ici : sans AlloDons raccordé (ou pour un agent), Contacts
 * ignore `tab=donors` et montre « Tous » — l'ancien refus (porte AlloDons, retirée)
 * n'a plus de page à protéger.
 */
import { Navigate, useLocation } from 'react-router-dom'

export const DONOR_HISTORY_LEGACY_PATH = '/donations/history'

/** `?q=x&tab=unmatched` ⇒ `/contacts?q=x&tab=donors`. Exportée pour les tests. */
export function donorHistoryTarget(search: string): string {
  const params = new URLSearchParams(search)
  params.set('tab', 'donors')
  return `/contacts?${params.toString()}`
}

export function DonorHistoryRedirect() {
  const location = useLocation()
  return <Navigate to={donorHistoryTarget(location.search)} replace />
}

export default DonorHistoryRedirect
